<template>
  <el-dialog
    :close-on-click-modal="false"
    title="支付预付款"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="1000px"
  >
    <section v-loading="getDetailLoading">
      <qx-detail-box :data="detailData">
        <span slot="preCashFee"> {{ prePayInfo.preCashFee }}元 </span>
        <span slot="preOilVirtualFee">
          {{ prePayInfo.preOilTotalFee }}元
          <template v-if="prePayInfo.preOilTotalFee !== '0.00'">
            （其中虚拟油费：{{ prePayInfo.preOilVirtualFee }}元，实体油卡：{{
              prePayInfo.preOilFee
            }}元）
          </template>
        </span>
        <span slot="preEtcFee"> {{ prePayInfo.preEtcFee }}元 </span>
      </qx-detail-box>

      <OilcardInfo
        ref="oilcardInfo"
        v-for="(item, index) in oilcardList"
        :oilcardData="item"
        :oilcardIndex="index"
        :itemData="originData"
        :key="index"
        @getOilCardInfo="getOilCardInfo"
        @getOilCardList="getOilCardList"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="sub"
        :loading="subLoading || getDetailLoading"
        >确 定</el-button
      >
    </section>
  </el-dialog>
</template>

<script>
import {
  orderPayPrepay,
  getOrderOilCard,
  getCustomOil,
  getOilCardByCarNum,
} from 'api/operate';
import { manageRechargeReceiptAccount } from 'api/cost';
import {
  isExist,
} from '@qx/utils/index';
import OilcardInfo from './oilcardInfo/oilcardInfo';
export default {
  components: {
    OilcardInfo,
  },
  data () {
    return {
      prePayInfo: {},
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      detailData: {
        label: '支付信息',
        tableData: {
          title: [
            {
              prop: 'preCashFee',
              label: '现金',
              slot: true,
            },
            {
              prop: 'preEtcFee',
              label: 'ETC',
              slot: true,
            },
            {
              prop: 'preOilVirtualFee',
              label: '油费',
              slot: true,
            },
          ],
          data: {

          },
          approveData: {

          },
        },
      },

      oilcardList: [],
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗

      this.prePayInfo = {
        preCashFee: isExist(item.preCashFee) ? (item.preCashFee / 100.0).toFixed(2) : '0.00',
        preEtcFee: isExist(item.preEtcFee) ? (item.preEtcFee / 100.0).toFixed(2) : '0.00',
        preOilFee: isExist(item.preOilFee) ? (item.preOilFee / 100.0).toFixed(2) : '0.00',
        preOilVirtualFee: isExist(item.preOilVirtualFee) ? (item.preOilVirtualFee / 100.0).toFixed(2) : '0.00',
      };
      this.prePayInfo.preCashFee = (Number(isExist(item.subsidyFeeSum) ? (item.subsidyFeeSum / 100.0) : 0) + Number(this.prePayInfo.preCashFee)).toFixed(2);
      this.prePayInfo.preOilTotalFee = (Number(this.prePayInfo.preOilFee) + Number(this.prePayInfo.preOilVirtualFee)).toFixed(2);

      this.originData = item;
      this.detailData.tableData.data = item;

      // console.log(item);


      if (item.paymentWay === 2 && item.preOilFee >= 0) {
        this.getOrderOilCard(item);
      } else {
        if (item.preOilFee > 0) {
          this.getOrderOilCard(item);
        }
      }
    },

    // 获取每张油卡的信息
    getOilCardInfo (item, index) {
      this.$set(this.oilcardList, index, item);
    },

    // 获取油卡列表，以及油卡是否足够
    async getOilCardList (item) {
      let cardNums = [];
      for (let itemCardNum of this.oilcardList) {
        cardNums.push(itemCardNum.oilCarNum);
      }
      const data = await getOilCardByCarNum({
        orderId: this.originData.orderId,
        cardNums: cardNums.join(','),
      });
      if (!data.failed) {
        if (isExist(data)) {
          if (data.listOut !== null && data.listOut.length > 0) {
            this.oilcardList = data.listOut;
            if (!data.isEnough) {
              this.oilcardList.push({
                chooseOilCardNum: '',
                oilCardNum: '',
                cardTypeName: '',
                cardBalance: 0,
              });
            }
          } else {
            this.$message({
              type: 'warning',
              message: '该油卡不存在！',
            });
          }
        }
      }
    },

    async getOrderOilCard (item) {
      const data = await getOrderOilCard({
        orderId: item.orderId,
        plateNumber: item.plateNumber,
      });
      if (!data.failed) {
        this.oilcardList = [];
        if (isExist(data) && isExist(data.oilCarNum) && (item.paymentWay === null || item.paymentWay !== 2)) {
          // 如果有卡号，根据油卡号获取卡类型和理论金额
          this.oilcardList = [
            {
              chooseOilCardNum: '',
              cardTypeName: '',
              cardBalance: 0,
            },
          ];

        } else if (item.paymentWay === 2) {
          // 返回油卡数组，显示油卡信息，显示 preOilFee 信息
          if (Array.isArray(data)) {
            this.oilcardList = data;
          }
        } else if (data.length > 0 && isExist(data[0].oilCardNum)) {
          // 返回油卡数组，显示油卡信息，显示 cardBalance 信息
          if (Array.isArray(data)) {
            this.oilcardList = data;
          }
        } else {
          // 可输入油卡
          this.oilcardList = [
            {
              chooseOilCardNum: '',
              cardTypeName: '',
              cardBalance: 0,
            },
          ];
        }
      }
    },

    // 判断分配油账户余额
    async checkOilAccount () {
      this.subLoading = true;
      let data = await getCustomOil({
        orderId: this.originData.orderId,
      });
      this.subLoading = false;
      if (!data.failed) {
        let preOilVirtualFee = this.originData.preOilVirtualFee;
        let oilAccountType = this.originData.oilAccountType;
        let oilConsumer = this.originData.oilConsumer;
        // let invoiceOilBalance = 0;
        let zyinvoiceOilBalance = 0;
        let wjyinvoiceOilBalance = 0;

        if (preOilVirtualFee > 0) {

          if (!isExist(data)) {
            data = {
              deductOilBalance: 0,
              zydeductOilBalance: 0,
              wjydeductOilBalance: 0,
              nonDeductOilBalance: 0,
              zynonDeductOilBalance: 0,
              wjynonDeductOilBalance: 0,
              custOilBalance: 0,
              zycustOilBalance: 0,
              wjycustOilBalance: 0,
              rebateOilBalance: 0,
              zyrebateOilBalance: 0,
              wjyrebateOilBalance: 0,
              transferOilBalance: 0,
              zytransferOilBalance: 0,
              wjytransferOilBalance: 0,
            };
          }

          // invoiceOilBalance = Number(data.rebateOilBalance) + Number(data.transferOilBalance);
          zyinvoiceOilBalance = Number(data.zyrebateOilBalance) + Number(data.zytransferOilBalance);
          wjyinvoiceOilBalance = Number(data.wjyrebateOilBalance) + Number(data.wjytransferOilBalance);
          if (this.originData.vehicleClass !== null && this.originData.vehicleClass === 1) {
            // invoiceOilBalance += Number(data.custOilBalance);
            zyinvoiceOilBalance += Number(data.zycustOilBalance);
            wjyinvoiceOilBalance += Number(data.wjycustOilBalance);
          }

          // 判断充值账户(非抵扣油)是否充足
          if (oilAccountType === 3) {
            // 判断当前车队的充值账户中票据要求为运输专票，同时充值账户名与当前订单的收票主体相同的油费是否充足
            if (oilConsumer === 2 && preOilVirtualFee > data.zynonDeductOilBalance) {
              // 关闭当前弹窗
              this.dialogFormVisible = false;
              const confirmRes = await this.$confirm('找油网账户中【有发票账户】余额不足，是否前往充值？', '提示', {
                confirmButtonText: '马上充值',
                cancelButtonText: '稍后充值',
                type: 'warning',
              }).catch(() => {
                // 取消
              });
              if (confirmRes === 'confirm') {
                // 马上充值
                this.getRechargeInfo();
              }
              return false;
            }
            if (oilConsumer === 3 && preOilVirtualFee > data.wjynonDeductOilBalance) {
              // 关闭当前弹窗
              this.dialogFormVisible = false;
              const confirmRes = await this.$confirm('万金油账户中【有发票账户】余额不足，是否前往充值？', '提示', {
                confirmButtonText: '马上充值',
                cancelButtonText: '稍后充值',
                type: 'warning',
              }).catch(() => {
                // 取消
              });
              if (confirmRes === 'confirm') {
                // 马上充值
                this.getRechargeInfo();
              }
              return false;
            }
          }
        } else if (oilAccountType === 2 && oilConsumer === 2 && preOilVirtualFee > zyinvoiceOilBalance) {
          // 关闭当前弹窗
          this.dialogFormVisible = false;
          // 判断已开票账户余额是否充足
          this.$message({
            type: 'warning',
            message: '找油网账户中“无发票账户”余额不足，请选择其他账户',
          });
          return false;
        } else if (oilAccountType === 3 && oilConsumer === 3 && preOilVirtualFee > wjyinvoiceOilBalance) {
          // 关闭当前弹窗
          this.dialogFormVisible = false;
          // 判断已开票账户余额是否充足
          this.$message({
            type: 'warning',
            message: '找油网账户中“无发票账户”余额不足，请选择其他账户',
          });
          return false;
        }
        this.savePrePay(this.originData);
      }
    },

    async getRechargeInfo () {
      const res = await manageRechargeReceiptAccount({
        oilRechargeType: this.originData.oilConsumer,
      });
      if (!res.failed) {
        if (this.originData.oilConsumer === 2) {
          this.jump({
            label: '新增管理费用',
            url: '/manage/cost/manage/edit?payType=4308',
            full: true,
          });
        }
        if (this.originData.oilConsumer === 3) {
          this.jump({
            label: '新增管理费用',
            url: '/manage/cost/manage/edit?payType=4316',
            full: true,
          });
        }
      }
    },

    async savePrePay (item) {
      let msg = '';
      if (item.isPreFinallyNode) {
        msg = '确认支付订单' + item.orderId + '的预付款，金额为' + ((item.preTotalFee === null ? 0 : item.preTotalFee / 100).toFixed(2)) + '元 ？';
      } else {
        msg = '确认同意？';
      }

      const confirmRes = await this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => {
        // 取消
      });
      if (confirmRes === 'confirm') {
        let oilCardNum = [];
        for (let i = 0; i < this.oilcardList.length; i++) {
          oilCardNum.push(this.oilcardList[i].oilCarNum);
        }

        const param = {
          orderId: item.orderId,
          auditCode: 300006,
          // 不知道哪里来的值
          verifyDesc: '',
          oilCardNum: oilCardNum.join(),
        };

        this.subLoading = true;
        const resSavePrePay = await orderPayPrepay(param);
        this.subLoading = false;
        if (!resSavePrePay.failed) {
          this.dialogFormVisible = false; // 关闭弹窗
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.$emit('sub');
        }
      }
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {

      this.checkOilAccount();

      // this.subLoading = true;
      // const res = await orderPayPrepay({
      //   orderId: this.originData.orderId,
      //   auditCode: 300006,
      // });
      // this.subLoading = false;
      // if (!res.failed) {
      //   this.dialogFormVisible = false; // 关闭弹窗
      //   this.$message({
      //     type: 'success',
      //     message: '保存成功',
      //   });
      //   this.$emit('sub');
      // }

    },
  },
};
</script>

<style lang="scss" scoped>
.oilCardNum-tip {
  margin-left: 16px;
  .item {
    margin-right: 8px;
  }
}
</style>
